import { ReactElement, useState } from 'react'
import { Box } from '@mui/material'
import CommentsListPane from '@editor/components/CommentsListPane'
import {
  COMMENTS_ELEMENT_LIST_TAB,
  IMAGE_CARDS_ELEMENT_LIST_TAB,
  TABLES_ELEMENT_LIST_TAB,
} from '@editor/components/ElementListPane'
import ImageCardsListPane from '@editor/components/ImageCardsListPane'
import TablesListPane from '@editor/components/TablesListPane'
import { NRowTabHeader } from '@ui2/navigation'
import { useSelectionStore } from '@editorStores'
import { PLAN_VIEW_PLAN_ELEMENT_LIST_BY_TYPE, PlanViewPlanElementListId } from '../../constants'

const LIST_TABS = [TABLES_ELEMENT_LIST_TAB, COMMENTS_ELEMENT_LIST_TAB, IMAGE_CARDS_ELEMENT_LIST_TAB]

/**
 * List column of the plan view: the project's tables, comments and plan images, the same lists as
 * the element list tabs of Tragwerksplanung. Selecting one in the scene switches to its list; its
 * form replaces the plan view in the detail column.
 */
const PlanViewPlanElementList = (): ReactElement => {
  const planElementType = useSelectionStore(state => state.planSelection?.planElementType ?? null)
  const [list, setList] = useState<PlanViewPlanElementListId>(
    () => (planElementType && PLAN_VIEW_PLAN_ELEMENT_LIST_BY_TYPE[planElementType]) || 'comments',
  )

  // Follow the selection: a newly selected table, comment or image card reveals its list.
  const [followedType, setFollowedType] = useState(planElementType)
  if (planElementType !== followedType) {
    setFollowedType(planElementType)
    const selectedList = planElementType && PLAN_VIEW_PLAN_ELEMENT_LIST_BY_TYPE[planElementType]
    if (selectedList) setList(selectedList)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <NRowTabHeader
        value={list}
        onChange={id => setList(id as PlanViewPlanElementListId)}
        showLabels
        rows={1}
        items={LIST_TABS.map(tab => ({
          id: tab.id,
          label: tab.label,
          shortLabel: tab.shortLabel,
          shortIcon: tab.shortIcon,
        }))}
      />
      <Box sx={{ flex: 1, minHeight: 0 }}>
        {list === 'tables' ? (
          <TablesListPane />
        ) : list === 'comments' ? (
          <CommentsListPane />
        ) : (
          <ImageCardsListPane />
        )}
      </Box>
    </Box>
  )
}

export default PlanViewPlanElementList
